import "./login.scss";
import images from "../../assets/imgs";
import { Button } from "antd";
import { ENV } from "../../constants/env";
import { useSearchParams } from "react-router-dom";
import { APP_VERSION } from "../../constants/version";

const LoginPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  const domain = window.location.origin;
  const handleLogin = () => {
    window.location.href = `${ENV.redirectUrl}${ENV.clientId}${domain}/oauth2/callback&response_type=code&scope=openid profile email&prompt=select_account`;
  };

  return (
    <div className="page-login">
      <div className="box">
        <div>
          <img alt="logo" className="logo" src={images.logo} />
          <h2>Cost Handling Invoice Processor</h2>
          
          {error === "SESSION_EXPIRED" && (
            <div className="error-message">
              <div className="error-title">Session Expired</div>
              <div className="error-description">
              Your session has expired due to time limit. Log in again to continue.
              </div>
            </div>
          )}
          
          <Button type="primary" size="large" onClick={handleLogin}>
            Login with SSO
          </Button>
        </div>
        <div className="version">Version: {APP_VERSION}</div>
      </div>
    </div>
  );
};

export default LoginPage;
